import React, { useState, useEffect } from 'react'
import { makeStyles } from '@mui/styles'
import Dialog from '@mui/material/Dialog'

import lang from 'lang'
import { TextInput, SelectInput } from '../inputs/index'
import { CancelButton } from '../buttons/index'

export const OcrModal = (props) => {
  const {
    open,
    text: ocrText,
    selectOptions,
    onFinish,
    onClose,
    customClasses,
  } = props

  const styles = useStyles(props)
  const classes = { ...styles, ...customClasses }
  const [text, setText] = useState(ocrText)

  useEffect(() => {
    if (!open) { return setText() }

    setText(ocrText)
  }, [open])

  const handleOcrManualChange = (value) => {
    setText(value)
  }
  const handleSelectChange = (option) => {
    onFinish && onFinish({ text, field: option.value })
  }
  const handleModalClose = () => {
    onClose && onClose()
  }

  const {
    documents: {
      ocr,
    },
  } = lang

  return (
    <Dialog
      open={open}
      classes={{ paper: classes.modal }}
      onClose={handleModalClose}>
      <h1 className={classes.header}>{ocr.header}</h1>
      <div className={classes.content}>
        <TextInput value={text} label={ocr.textLabel} onChange={handleOcrManualChange} />
        <div className={classes.select}>
          <SelectInput
            label={ocr.selectLabel}
            notAsync
            allowCreate={false}
            options={selectOptions}
            handleChange={handleSelectChange} />
        </div>
      </div>
      <div className={classes.actions}>
        <CancelButton label={lang.cancelButtonLabel} onClick={handleModalClose} />
      </div>
    </Dialog>
  )
}

const useStyles = makeStyles((theme) => ({
  modal: {
    width: 500,
    padding: '40px 40px 0px 40px',
    minHeight: 430,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 100%',
    marginTop: 20,
    '& label': {
      color: theme.labelLight,
    },
  },
  select: {
    marginTop: 20,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    flex: '1 0 100%',
    marginTop: 20,
  },
  header: {
    margin: 0,
    fontSize: 24,
    fontWeight: 400,
  },
}))

export default OcrModal
